import {
    HouseholdInvitation,
    HouseholdInvitationWithHouseholdName,
} from '@/features/household/models/invitation';
import {
    AcceptHouseholdInvitationDTO,
    CreateHouseholdInvitationDTO,
    DeclineHouseholdInvitationDTO,
    HouseholdInvitationDTO,
    HouseholdInvitationWithHouseholdNameDTO,
    RevokeHouseholdInvitationDTO,
} from '@/features/household/dto/invitation_dto';
import {
    AcceptHouseholdInvitationForm,
    DeclineHouseholdInvitationForm,
    CreateHouseholdInvitationForm,
    RevokeHouseholdInvitationForm,
} from '@/features/household/form/invitation_form';

export function fromHouseholdInvitationDTO(dto: HouseholdInvitationDTO): HouseholdInvitation {
    return {
        id: dto.id,
        householdId: dto.household_id,
        email: dto.email,
        token: dto.token,
        role: dto.role,
        status: dto.status,
        expiresAt: dto.expires_at,
        usedAt: dto.used_at,
        createdAt: dto.created_at,
        updatedAt: dto.updated_at,
    }
}

export function fromHouseholdInvitationWithHouseholdNameDTO(dto: HouseholdInvitationWithHouseholdNameDTO): HouseholdInvitationWithHouseholdName {
    return {
        id: dto.id,
        householdName: dto.household_name,
        email: dto.email,
        role: dto.role,
        token: dto.token,
        status: dto.status,
        expiresAt: dto.expires_at,
        createdAt: dto.created_at,
        updatedAt: dto.updated_at,
    }
}

export function toHouseholdInvitationDTO(invitation: HouseholdInvitation): HouseholdInvitationDTO {
    return {
        id: invitation.id,
        household_id: invitation.householdId,
        email: invitation.email,
        token: invitation.token,
        role: invitation.role,
        status: invitation.status,
        expires_at: invitation.expiresAt,
        used_at: invitation.usedAt,
        created_at: invitation.createdAt,
        updated_at: invitation.updatedAt,
    }
}

export function toCreateHouseholdInvitationDTO(form: CreateHouseholdInvitationForm): CreateHouseholdInvitationDTO {
    return {
        email: form.email,
        role: form.role,
    }
}

export function toRevokeHouseholdInvitationDTO(form: RevokeHouseholdInvitationForm): RevokeHouseholdInvitationDTO {
    return {
        invitation_id: form.invitationId,
    }
}

export function toAcceptHouseholdInvitationDTO(form: AcceptHouseholdInvitationForm): AcceptHouseholdInvitationDTO {
    return {
        token: form.token,
    }
}

export function toDeclineHouseholdInvitationDTO(form: DeclineHouseholdInvitationForm): DeclineHouseholdInvitationDTO {
    return {
        token: form.token,
    }
}
